<script setup lang="ts">
/**
 * @author Beka Chkhaidze
 * @summary add appropriate classes to complex component
 */
import { computed } from "vue";
import { generateClasses } from "../ts/util";
import type { ComplexComponentItem } from "../ts/Content.interface";

const props = defineProps<{
  conf: ComplexComponentItem["conf"];
}>();

const classes = computed(() => generateClasses(props.conf));
</script>

<template>
  <section class="complex-components__item">
    <div :class="classes">
      <slot />
    </div>
  </section>
</template>
